/**
 * External dependencies
 */
import { isArray } from "lodash";
import moment from "moment";

export const determineGranularity = (dateRange) => {
  if (isArray(dateRange)) {
    let d1 = moment(dateRange[0], "YYYY-MM-DD:HH:mm:ss");
    let d2 = moment(dateRange[1], "YYYY-MM-DD:HH:mm:ss");

    let difference = d2 ? d2.diff(d1, "days") : 61;

    if (difference <= 60) {
      return "day";
    }
  }
  return "week";
};
